import PropTypes from 'prop-types'

// Plan cards side by side, every plan on one row from the `lg` breakpoint. Full class strings so
// Tailwind keeps them; past six plans the row wraps rather than squeezing the cards.
const COLUMNS = {
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-2 lg:grid-cols-4',
  5: 'md:grid-cols-2 lg:grid-cols-5',
  6: 'md:grid-cols-3 lg:grid-cols-6'
}

/**
 * Classes for a card. A card is made of seven slots, top to bottom: name, tagline, price, features,
 * limits, perks, button. Each slot is a row track shared by every card in the grid (CSS subgrid), so
 * the same slot sits at the same height on every card even when one card has a discount line, a longer
 * tagline or more features than its neighbours, and every card ends up the same height. A card must
 * always render all seven slots, empty ones included, so later slots don't slide up.
 */
export const PLAN_CARD_CLASS = 'grid grid-rows-subgrid row-span-7 gap-y-0'

export const planGridColumnsClass = (count) => COLUMNS[Math.min(Math.max(count, 1), 6)]

export const PlanGrid = ({ count, className = '', children }) => (
  <div className={`grid grid-cols-1 gap-5 ${planGridColumnsClass(count)} ${className}`.trim()} data-testid='plan-grid'>
    {children}
  </div>
)
PlanGrid.propTypes = {
  /** How many cards the grid holds (one column each). */
  count: PropTypes.number.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
}
